import React from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useSession } from '../contexts/SessionContext';
import EnhancedPreview from '../components/EnhancedPreview';
import NextButton from '../components/NextButton';
import RouteGuard from '../components/RouteGuard';
import './css/PreviewPage.css';
import '../styles/burger-menu.css';
import useScrollDirection from '../hooks/useScrollDirection';

function PreviewPage () {
  const location = useLocation();
  const { currentSession } = useSession();
  const { scrollDirection, isAtTop } = useScrollDirection();
  const selectedDesign = location.state?.design || currentSession?.design || 'Design1';

  const handleMenuToggle = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.dispatchEvent(new CustomEvent('toggleNavigationMenu'));
  };

  return (
    <RouteGuard requiresImage={true} requiresAudio={true} redirectTo="/images">
      <div className="preview-page">
        <div className="preview-content">
          <div className="preview-header-card">
            <div className="page-header-with-menu">
              <button
                className={`page-header-menu-button ${scrollDirection === 'down' && !isAtTop ? 'hide-on-scroll' : ''}`}
                onClick={handleMenuToggle}
                onTouchEnd={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleMenuToggle(e);
                }}
                type="button"
                aria-label="Open menu"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
              <h1 className="h2 page-title-mobile">Preview</h1>
              <h1 className="h2 page-title-desktop">Preview</h1>
            </div>
            <p className="preview-description">
              See how your video will look. Use the controls below to play a preview.
            </p>
          </div>
          
          <EnhancedPreview design={selectedDesign} showControls={true} />

          <div className="page-navigation">
            <NextButton 
              nextPath="/export" 
              text="Export Video"
              className="success"
            />
          </div>
        </div>
      </div>
    </RouteGuard>
  );
}

export default PreviewPage;
